const DEFAULTS = {
  tenant: 'edugep',
  api_base: 'https://agentes.aisolutions.pt',
  webhook_path: '/webhook/edugep-etibox-widget',
  chips_config_url: 'https://widget.aisolutions.pt/chips.json',
  whitelist_url: 'https://widget.aisolutions.pt/whitelist.json',
  bubble_position: 'bottom-right',
  session_storage_key: 'ai_etibox_session_id',
  allowed_hosts: ['etibox.edugep.pt', 'widget.aisolutions.pt', 'localhost', '127.0.0.1']
}

export function readConfig() {
  const user = (typeof window !== 'undefined' && window.AI_ETIBOX_CONFIG) || {}
  return { ...DEFAULTS, ...user }
}

// O mesmo template PHP serve a ETI Box da EDUGEP e a da AI9 (etibox.ai9.pt). Este widget é só da EDUGEP.
export function isHostAllowed(config) {
  if (typeof window === 'undefined') return false
  const hosts = Array.isArray(config?.allowed_hosts) ? config.allowed_hosts : []
  return hosts.includes(window.location?.hostname)
}

export function readEE() {
  if (typeof window === 'undefined') return null
  const raw = window.AI_ETIBOX_EE
  if (!raw || typeof raw !== 'object') return null
  if (!raw.id || !raw.token) return null
  return {
    id: String(raw.id),
    token: String(raw.token),
    email: raw.email ? String(raw.email) : null,
    validated: raw.validated === false ? false : true
  }
}

export function currentPage() {
  if (typeof window === 'undefined') return '/'
  return window.location?.pathname || '/'
}

export function getUserState(ee) {
  if (!ee) return 1
  return ee.validated === false ? 2 : 3
}

// Com a whitelist aberta, visitantes sem sessão (ee null) também veem o widget, em Estado 1.
export async function isEEAllowed(ee, config) {
  if (config?.whitelist_open === true) return true
  if (ee?.id && Array.isArray(config?.ee_ids_allowed) && config.ee_ids_allowed.includes(ee.id)) return true
  try {
    const res = await fetch(config.whitelist_url, { method: 'GET', cache: 'no-cache' })
    if (!res.ok) return false
    const data = await res.json()
    if (data?.open === true) return true
    if (!ee?.id) return false
    const list = Array.isArray(data?.ee_ids) ? data.ee_ids : []
    return list.includes(ee.id)
  } catch {
    return false
  }
}
